<template>
  <div class="relative" ref="containerRef">
    <button
      @click="open = !open"
      class="flex items-center gap-2 h-9 px-3 border border-slate-300 rounded-lg text-sm bg-white hover:bg-slate-50 hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-header transition-colors shadow-sm"
    >
      <span>Workstreams</span>
      <span v-if="hiddenCount > 0" class="bg-header text-white text-xs rounded-full px-1.5 py-0.5">
        {{ hiddenCount }} hidden
      </span>
      <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <div
      v-if="open"
      class="absolute right-0 mt-1 w-96 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto text-gray-800"
    >
      <div class="p-2 border-b border-gray-100 flex items-center justify-between gap-2">
        <span class="text-xs text-gray-500 font-medium">Workstreams</span>
        <input
          v-model="search"
          placeholder="Search..."
          class="flex-1 text-sm px-2 py-1 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-header text-gray-800"
        />
        <button @click="selectAll" class="text-xs text-header hover:underline whitespace-nowrap">All</button>
        <button @click="clearAll" class="text-xs text-gray-400 hover:underline whitespace-nowrap">None</button>
      </div>
      <ul class="py-1">
        <li
          v-for="ws in filteredWorkstreams"
          :key="ws"
          class="flex items-center gap-2 px-3 py-1.5 hover:bg-gray-50 cursor-pointer text-gray-800"
          @click="toggle(ws)"
        >
          <input
            type="checkbox"
            :checked="isVisible(ws)"
            class="w-4 h-4 accent-header cursor-pointer"
            @click.stop="toggle(ws)"
          />
          <span class="text-sm truncate text-gray-800" :title="ws">{{ ws }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  workstreams: { type: Array, default: () => [] },
  hiddenWorkstreams: { type: Set, default: () => new Set() }
})

const emit = defineEmits(['update:hiddenWorkstreams'])

const open = ref(false)
const search = ref('')
const containerRef = ref(null)

const filteredWorkstreams = computed(() =>
  props.workstreams.filter(ws =>
    ws.toLowerCase().includes(search.value.toLowerCase())
  )
)

const hiddenCount = computed(() => props.hiddenWorkstreams.size)

const isVisible = (ws) => !props.hiddenWorkstreams.has(ws)

const toggle = (ws) => {
  const updated = new Set(props.hiddenWorkstreams)
  if (updated.has(ws)) {
    updated.delete(ws)
  } else {
    updated.add(ws)
  }
  emit('update:hiddenWorkstreams', updated)
}

const selectAll = () => emit('update:hiddenWorkstreams', new Set())
const clearAll = () => emit('update:hiddenWorkstreams', new Set(props.workstreams))

const handleClickOutside = (e) => {
  if (containerRef.value && !containerRef.value.contains(e.target)) {
    open.value = false
  }
}

onMounted(() => document.addEventListener('mousedown', handleClickOutside))
onUnmounted(() => document.removeEventListener('mousedown', handleClickOutside))
</script>
